import React from 'react'
import { makeStyles } from '@material-ui/core'
import PolicyCard from 'src/components/RiskReports/UpComingRenewals/PolicyCard'

const RenewalPolicies = ({ groupedPolicies }) => {
  const classes = useStyles()
  return (
    <>
      {groupedPolicies?.length ? (
        <>
          {groupedPolicies?.map((policyGroup, ind) => {
            return (
              <div key={`policyGroup_${ind}`}>
                <span className={classes.groupTitle}>
                  {policyGroup?.insuranceType}
                </span>
                <div className={classes.policyCardContainer}>
                  {policyGroup?.policies?.map((policy, index) => (
                    <PolicyCard policy={policy} key={`renewals${index}`} />
                  ))}
                </div>
              </div>
            )
          })}
        </>
      ) : (
        <span className={classes.noDataText}>No Policies Available</span>
      )}
    </>
  )
}
export default RenewalPolicies

const useStyles = makeStyles({
  policyCardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  groupTitle: {
    textAlign: 'left',
    width: '100%',
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'flex',
    margin: '10px',
  },
  noDataText: {
    opacity: '0.3',
    fontWeight: 'bold',
  },
})
